module.exports = __webpack_public_path__ + "img/logo.6ed289c2.png";